import { Dispatch } from "redux";
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes";
import { ApiConfig } from "../../../../../config/ApiConfig";
import { AppStateWithData } from "../../../../AppStateWithData";
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk";

export interface UpdateLastChatAdditionalData {
    chatUId: string,
}
type UpdateLastUserEnterChatBody = string

export const getUpdateLastUserEnterChatDMActionTypes = createRequestActionTypes('UPDATE_LAST_USER_ENTER_CHAT_DM')

export const updateLastUserEnterChatDM = (config: ApiConfig) => (chatUId: string) => (dispatch: Dispatch, getState: () => AppStateWithData) => {
    const thunkParams: RequestThunkParameters<boolean, UpdateLastUserEnterChatBody, UpdateLastChatAdditionalData> = {
        method: 'POST',
        requestActionTypes: getUpdateLastUserEnterChatDMActionTypes,
        url: `${config.API_URL}/chat/updateLastSeen`,
        body: chatUId,
        actionAdditionalData: {
            chatUId
        },
    }

    return dispatch<any>(createRequestThunk(thunkParams))
}

